// extracted by mini-css-extract-plugin
module.exports = {"footer":"style-module--footer--38qRu","forbesLogo":"style-module--forbesLogo--31W3S"};